// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chess';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.656 13.25h3.881a1.063 1.063 0 0 1 1.048.887l.37 1.063a1.064 1.064 0 0 1-1.049 1.238h-3.718M2.492 13.25v-.78a6.487 6.487 0 0 1 2.435-5.064H2.064a1.033 1.033 0 0 1-.73-1.763l2.62-2.621v-1.46l.258.058a5.262 5.262 0 0 1 4.119 5.142v.644c-2.435 2.436.488 5.858.488 5.858m2.371-6.218-.741 4.079m4.395 2.125-1.128-6.203m-3.653-2.031a2.39 2.39 0 1 0 4.781 0 2.39 2.39 0 0 0-4.781 0z' />
    <path d='m10.008 15.04-.354-1.063a1.062 1.062 0 0 0-1.008-.727H2.448a1.062 1.062 0 0 0-1.008.727l-.354 1.062a1.062 1.062 0 0 0 1.008 1.399H9a1.062 1.062 0 0 0 1.008-1.399z' />
  </g>
);

export const viewBox = '0 0 18 18';
